/** Header for claim-register Submit intent (client → CB → claims-service). */
export const IDEMPOTENCY_KEY_HEADER = "X-Idempotency-Key";

/**
 * UUID v4 for one claim-register Submit intent.
 * Reuse for transport retries of that intent; mint again on a new Submit.
 */
export function createIdempotencyKey(): string {
  if (
    typeof globalThis !== "undefined" &&
    typeof globalThis.crypto?.randomUUID === "function"
  ) {
    return globalThis.crypto.randomUUID();
  }

  let d = Date.now();
  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    d += performance.now();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-bitwise
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/** Pass through when a caller set X-Idempotency-Key (enhanceRequestHeaders rebuilds). */
export function pickIdempotencyKeyHeader(
  headers?: Record<string, unknown> | null
): Record<string, string> {
  if (!headers) return {};
  const value = headers[IDEMPOTENCY_KEY_HEADER];
  if (typeof value === "string" && value !== "") {
    return { [IDEMPOTENCY_KEY_HEADER]: value };
  }
  return {};
}
